// frontend/src/components/common/GlobalOverlay/useOverlayAnimation.js
import { useState, useEffect, useRef } from 'react';

export const useOverlayAnimation = (duration = 400) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const timerRef = useRef(null);

  const animateIn = () => {
    setIsAnimating(true);
    setIsVisible(true);
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      setIsAnimating(false);
    }, duration);
  };

  const animateOut = (callback) => {
    setIsAnimating(true);
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      setIsVisible(false);
      setIsAnimating(false);
      if (callback) callback();
    }, duration);
  };

  useEffect(() => {
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  return {
    isVisible,
    isAnimating,
    animateIn,
    animateOut,
  };
};